export const UrlUtil = {
    queryString: function(name, url){
    	if(!name) return null;
		if (!url) url = window.location.href;
		name = name.replace(/[\[\]]/g, "\\$&");
		let regex = new RegExp(`(?:[?&]${name})(?:=([^&#]*)|&|#|$)`, "ig");
		let results = [], r;
		while(r = regex.exec(url)) results.push(r[1]);
		if (!results.length) return null;
		if(results.length === 1) return results[0] ? decodeURIComponent(results[0].replace(/\+/g, " ")) : true;
		results = Array.prototype.map.call(results, (item) => {
			if(item) return decodeURIComponent(item.replace(/\+/g, " "));
			else return true;
		});
		return results;
	},

	addParameter: function(url, key, value, replaceExisting){
    	if(!key) return;
    	if(!url) url = window.location.href;
    	const queryResult = this.queryString(key, url);
    	const stringPresent = queryResult && (queryResult === value.toString() || Array.prototype.filter.call(queryResult, item => item === value.toString()).length);
    	if(stringPresent) replaceExisting = true;
		let re = new RegExp(`([?&])${key}=.*?(&|$)`, "i");
		let separator = url.indexOf('?') !== -1 ? (url.indexOf('?') + 1 === url.length ? "" : "&") : "?";
		if (replaceExisting && url.match(re) && typeof value !== "undefined" && value !== null){
			return url.replace(re, '$1' + key + "=" + value + '$2');
		}
        if(typeof value !== "undefined" && value !== null) {
			return url + separator + key + "=" + value;
        }
		else return url + separator + key;
	},

	removeParameter: function(url, key, value){
        let parameterString = `${key}=${value}`;
        if(url.indexOf(parameterString) < 0) return url;
        let re = new RegExp(`(${parameterString})(&|#|$)`, "ig");
        // if(!value){
		// 	re = new RegExp(`(?:(${key}))(?:=([^&#]*)(&|#|$))`, "ig");
         //    let results = [], r;
         //    while(r = re.exec(url)) results.push(r);
         //    [...results].map(e => `${key}=${e[1]}`)
		// }
		// else{
            url = url.replace(re, '');
		// }
		return url.lastIndexOf('&') === url.length - 1 ? url.substring(0, url.length-1) : url;

	}
};